export default class Roles {
  static get values() {
    return {
      owner: {
        id: 'owner',
        label: 'Owner',
        description: 'Access to all resources'
      },
      activityViewer: {
        id: 'activityViewer',
        label: 'Activity Viewer',
        description: 'Access to view all activities'
      },
      securityReviewer: {
        id: 'securityReviewer',
        label: 'Security Reviewer',
        description: `Full access to manage user's roles`
      },
      entityEditor: {
        id: 'entityEditor',
        label: 'Entity Editor',
        description: 'Edit access to all entities'
      },
      entityViewer: {
        id: 'entityViewer',
        label: 'Entity Viewer',
        description: 'View access to all entities'
      },
      clubEditor: {
        id: 'clubEditor',
        label: 'Club Editor',
        description: 'Edit access to clubs'
      },
      clubViewer: {
        id: 'clubViewer',
        label: 'Club Viewer',
        description: 'View access to clubs'
      },
      teamEditor: {
        id: 'teamEditor',
        label: 'Team Editor',
        description: 'Edit access to teams'
      },
      teamViewer: {
        id: 'teamViewer',
        label: 'Team Viewer',
        description: 'View access to teams'
      },
      teamManagerEditor: {
        id: 'teamManagerEditor',
        label: 'Team manager Editor',
        description: 'Edit access to team managers'
      },
      teamManagerViewer: {
        id: 'teamManagerViewer',
        label: 'Team manager Viewer',
        description: 'View access to team managers'
      },
      categoryEditor: {
        id: 'categoryEditor',
        label: 'Category Editor',
        description: 'Edit access to categories'
      },
      categoryViewer: {
        id: 'categoryViewer',
        label: 'Category Viewer',
        description: 'View access to categories'
      },
      playerEditor: {
        id: 'playerEditor',
        label: 'Player Editor',
        description: 'Edit access to players'
      },
      playerViewer: {
        id: 'playerViewer',
        label: 'Player Viewer',
        description: 'View access to players'
      },
      coachEditor: {
        id: 'coachEditor',
        label: 'Coach Editor',
        description: 'Edit access to coaches'
      },
      coachViewer: {
        id: 'coachViewer',
        label: 'Coach Viewer',
        description: 'View access to coaches'
      },
      managerEditor: {
        id: 'managerEditor',
        label: 'Manager Editor',
        description: 'Edit access to managers'
      },
      managerViewer: {
        id: 'managerViewer',
        label: 'Manager Viewer',
        description: 'View access to managers'
      },
      positionEditor: {
        id: 'positionEditor',
        label: 'Position Editor',
        description: 'Edit access to positions'
      },
      positionViewer: {
        id: 'positionViewer',
        label: 'Position Viewer',
        description: 'View access to positions'
      },
      documentEditor: {
        id: 'documentEditor',
        label: 'Document Editor',
        description: 'Edit access to documents'
      },
      documentViewer: {
        id: 'documentViewer',
        label: 'Document Viewer',
        description: 'View access to documents'
      },
      fieldManagerEditor: {
        id: 'fieldManagerEditor',
        label: 'Field manager Editor',
        description: 'Edit access to fieldManagers'
      },
      fieldManagerViewer: {
        id: 'fieldManagerViewer',
        label: 'Field manager Viewer',
        description: 'View access to fieldManagers'
      },
      refereeEditor: {
        id: 'refereeEditor',
        label: 'Referee Editor',
        description: 'Edit access to referees'
      },
      refereeViewer: {
        id: 'refereeViewer',
        label: 'Referee Viewer',
        description: 'View access to referees'
      },
      tournamentEditor: {
        id: 'tournamentEditor',
        label: 'Tournament Editor',
        description: 'Edit access to tournaments'
      },
      tournamentViewer: {
        id: 'tournamentViewer',
        label: 'Tournament Viewer',
        description: 'View access to tournaments'
      },

      // NEW!!
      clubManager: {
        id: 'clubManager',
        label: 'Club manager',
        description: 'View access to edit ( teams, players ) of club'
      },
    };
  }

  static labelOf(id) {
    if (!this.exists(id)) {
      return id;
    }

    return this.values[id].label;
  }

  static get asArray() {
    return Object.keys(this.values).map(
      (roleId) => this.values[roleId]
    );
  }

  static exists(role) {
    return !!this.values[role];
  }
}



// WEBPACK FOOTER //
// ./src/auth/roles.js